/* eslint-disable react/jsx-key */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Stage, Layer } from "react-konva";
// import * as Ramda from "ramda";

import State from "../../components/MachineElement/State.jsx";
// import MachineElement from "../../components/MachineElement/MachineElement";
import Transition from "../../components/MachineElement/Transition.jsx";
import "../Dashboard/Dashboard.css";
import { useDot } from "../../context/automatonContext";
import { useLoading } from "../../context/Feedback/loadingContext";
import { organizeArrayToRenderAutomata } from "../../utils/organizeRenderAutomata.js";
import Loading from "../../components/Loading/loading";
import { useSystem } from "context/systemContext.jsx";
import { useUser } from "../../context/userContext";
import DataService from "services/DataService.js";
import TableTransitions from "../../components/TableConvertAutomaton/Table.jsx";
import { useAlert } from "../../context/Feedback/alertContext";
import tableConstantes from "../../constants/ResponseArea/tables.js";
import dialogConstantes from "../../constants/ResponseArea/transformationDialog.js";
import CheckIcon from "@material-ui/icons/Check";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined";
import Tree from "react-d3-tree";
import MixedNodeElement from "../../components/NodoTree/NodoDerivationTree.jsx";
import DOT from "../../components/MachineElement/DOT";
import CopyIcon from "@material-ui/icons/FileCopyOutlined";
// import constants from "../../constants/automatonLabel";
import "./AutomatonResponse.css";

import { Button } from "@material-ui/core";
import TransformationAlgorithmdialog from "components/Dialogs/TransformationAlgorithm.jsx";
import SystemOff from "views/System/SystemOff.jsx";
import SimulateAutomata from "views/Simulate/SimulateAutomata.jsx";
// import SimulateAutomata from "views/Simulate/SimulateAutomata.jsx";

// const customNodeFnMapping = {
//   mixed: {
//     description: "MixedNodeElement - SVG `circle` + `foreignObject` label",
//     // eslint-disable-next-line react/display-name
//     fn: ({ nodeDatum, toggleNode }) => (
//       <MixedNodeElement
//         nodeData={nodeDatum}
//         triggerNodeToggle={toggleNode}
//         foreignObjectProps={{
//           width: 200,
//           height: 200,
//           x: -50,
//           y: 10,
//         }}
//         word="aa"
//         acceptance={true}
//       />
//     ),
//   },
// };

export default function AutomatonResponse() {
  //   const [childs1] = useState([]);
  // const [childs2] = useState([]);
  // const [states, setStates] = useState([]);
  // const [responseDot, setResponseDot] = useState([]);
  // const nodeSize = { x: 200, y: 200 };
  // const foreignObjectProps = { width: nodeSize.x, height: nodeSize.y, x: 20 };
  const history = useHistory();
  const {
    dot,
    setDot,
    drawableDot,
    setDrawableDot,
    machineTransitionsResponse,
    setMachineTransitionsResponse,
    machineStatesResponse,
    setMachineStatesResponse,
    responseTableAFNDLambda,
    responseTableAFND,
    responseTableAFD,
    responseTableMinimization,
    afndDot,
    responseSimulate,
    dataTreeDerivation,
    // setResponseAFNDLambda,
  } = useDot();
  const renderRectSvgNode = ({ nodeDatum, toggleNode }) => {
    let nodeWidth = 200;
    let nodeWord = [];
    if (responseSimulate.responseSimulateAutomata.word) {
      nodeWidth = responseSimulate.responseSimulateAutomata.word.length * 30;
      if (nodeWidth < 200) {
        nodeWidth = 200;
      }
      nodeWord = responseSimulate.responseSimulateAutomata.word.split("");
    }

    return (
      <MixedNodeElement
        nodeData={nodeDatum}
        triggerNodeToggle={toggleNode}
        foreignObjectProps={{
          width: nodeWidth,
          height: 200,
          x: -50,
          y: 10,
        }}
        word={nodeWord}
        acceptance={true}
      />
    );
  };

  const {
    credential,
    language,
    setActiveTransformationAlgorithmDialog,
    isAdmin,
  } = useUser();

  const { isAlive } = useSystem();
  const [dragEnd] = useState(false);
  const { setAlert } = useAlert();
  const [rows, setRows] = useState({});
  const [rowsAFD, setRowsAFD] = useState({});
  const [rowsAFND, setRowsAFND] = useState({});
  const [tableAFD, setTableAFD] = useState({});
  const [tableAFND, setTableAFND] = useState({});
  const [tableMinimization, setTableMinimization] = useState({});
  const [finalAndNotFinals, setFinalAndNotFinals] = useState({});
  const [reason, setReason] = useState({});
  const [subject, setSubject] = useState({});
  const [propagation, setPropagation] = useState({});
  const [propagationByKey, setPropagationByKey] = useState([]);
  const [disableNextButton, setDisableNextButton] = useState(false);
  const [disabledAlgorithmButton, setDisabledAlgorithmButton] = useState(false);
  const [disablePreviousButton, setDisablePreviousButton] = useState(false);
  const [tranT, setTranT] = useState([]);
  // const [renderCustomNodeElement] = useState(customNodeFnMapping["mixed"].fn);
  // const [propagationQueue, setPropagationQueue] = useState([]);
  const [alphabetAFNDLambda, setAlphabetAFNDLambda] = useState([
    tableConstantes.transitionTables.AFNDLambda[language],
  ]);
  const [alphabetAFD, setAlphabetAFD] = useState([
    tableConstantes.transitionTables.AFD[language],
  ]);
  const [alphabetAFND, setAlphabetAFND] = useState([
    tableConstantes.transitionTables.AFND[language],
  ]);
  const [headerTableMinimization] = useState(
    tableConstantes.minimizationHeader.map((e) => [...e[language]])
  );

  const [isTableAFND, setIsTableAFND] = useState(!!responseTableAFND.data);
  const [isTableAFD, setIsTableAFD] = useState(false);
  const [insertedFinalAndNotFinal, setInsertedFinalAndNotFinal] = useState(
    null
  );
  const [insertKeyMinimization, setInsertKeyMinimization] = useState(0);
  const [
    lastKeyMinimizationModificated,
    setlastKeyMinimizationModificated,
  ] = useState([{}]);
  const [arrayChangeColorCell, setArrayChangeColorCell] = useState([]);
  const [isOpenTableAFND, setIsOpenTableAFND] = useState(
    responseTableAFNDLambda.data == undefined && responseTableAFND.data
      ? true
      : false
  );
  const [isOpenTableAFD, setIsOpenTableAFD] = useState(false);
  const [isOpenTableMinimization, setIsOpenTableMinimization] = useState(false);
  const [contentDialog, setContentDialog] = useState("");
  const [titleDialog, setTitleDialog] = useState("");
  const [importantStatesAFNDLambda, setImportantStatesAFNDLambda] = useState(
    {}
  );
  const [importantStatesAFND, setImportantStatesAFND] = useState({});
  const [importantStatesAFD, setImportantStatesAFD] = useState({});
  const [importantStatesDraw, setImportantStatesDraw] = useState({});
  // const [
  //   importantStatesMinimization,
  //   setImportantStatesMinimization,
  // ] = useState({});
  const [stageWidth, setStageWidth] = useState(window.innerWidth);
  const [stageHight, setStageHight] = useState(window.innerHeight);

  const { loading, setLoading } = useLoading();
  const { setIsAlive } = useSystem();

  // function createData(initState, label, finalState) {
  //   let tempRows = [...rows];
  //   tempRows.push({ initState, label, finalState });
  //   setRows(tempRows);
  // }
  const stylesNodo = {
    nodes: {
      node: {
        circle: {
          fill: "#52e2c5",
        },
        attributes: {
          stroke: "#000",
        },
      },
      leafNode: {
        circle: {
          fill: "transparent",
        },
        attributes: {
          stroke: "#000",
        },
      },
    },
  };

  const fechTableMinimization = () => {
    let minimization = {};
    let tempFinalAndNotFinal = {};
    let tempReason = {};
    let tempSubject = {};
    let tempPropagation = {};
    // let arrayAlphabetAFD = [...alphabetAFND];

    if (responseTableMinimization.data != undefined) {
      setIsOpenTableMinimization(true);
      console.log(responseTableMinimization);
      responseTableMinimization.data.forEach((item) => {
        // const arrayStates = Object.values(responseTable.data)[index];
        let setState = item.split(";")[0];
        let condition = item.split(";")[1];
        let subject = item.split(";")[2];
        let reason = item.split(";")[3] != null ? item.split(";")[3] : "";
        // console.log(reason);
        subject = subject.replace("[", "").replace("]", "");
        let state1 = setState.split(", ")[0];
        let state2 = setState.split(", ")[1];
        state1 = state1.replaceAll(",", "");
        state2 = state2.replaceAll(",", "");
        setState = state1 + ", " + state2;
        if (subject != "") {
          const arraySubject = subject.split("),");
          arraySubject.forEach((key) => {
            if (!key.includes(")")) {
              key = key + ")";
            }
            key = key.trim();
            let s1 = key.split(", ")[0].replaceAll(",", "");
            let s2 = key.split(", ")[1].replaceAll(",", "");
            key = s1 + ", " + s2;
            if (tempSubject[key] == undefined) {
              tempSubject[key] = [setState];
            } else {
              tempSubject[key].push(setState);
            }
            if (tempPropagation[setState] == undefined) {
              tempPropagation[setState] = [key];
            } else {
              tempPropagation[setState].push(key);
            }
          });
        }
        if (condition == "true" && reason == "") {
          if (tempFinalAndNotFinal[setState] == undefined) {
            let initialState = setState.split(",")[0].replaceAll(",", "");
            let destinyState = setState.split(",")[1].replaceAll(",", "");
            let message = "";
            initialState = initialState.replace("(", "").trim();
            destinyState = destinyState.replace(")", "").trim();
            if (importantStatesDraw.final.includes(initialState)) {
              message = `${initialState} ∈ F ${destinyState} ∉ F`;
            } else {
              message = `${destinyState} ∈ F ${initialState} ∉ F`;
            }
            tempFinalAndNotFinal[setState] = [message];
          }
        } else if (condition == "true") {
          let r1;
          let r2;
          let reasonWithoutComas;
          if (reason == "") {
            reasonWithoutComas = reason;
          } else if (reason.substring(0, 1) != "[") {
            r1 = reason.split(", ")[0].replaceAll(",", "");
            r2 = reason.split(", ")[1].replaceAll(",", "");
            reasonWithoutComas = r1 + ", " + r2;
          }

          if (
            tempReason[setState] == undefined &&
            reason.substring(0, 1) != "["
          ) {
            tempReason[setState] = reasonWithoutComas;
          }
        }
        minimization[setState] = [
          setState,
          { name: "✔", color: "black" },
          "{ }",
          "",
        ];
      });
      // setAlphabetAFND(arrayAlphabetAFD);
      // setTableAFND(arrayAFD);
      // if (responseTableAFNDLambda.data == undefined) {
      //   setRowsAFND(arrayAFD);
      // }
      setFinalAndNotFinals({ ...tempFinalAndNotFinal });
      setReason({ ...tempReason });
      setSubject({ ...tempSubject });
      setPropagation({ ...tempPropagation });
    }
    console.log(minimization);

    setTableMinimization(minimization);
  };

  const fechTableAFND = () => {
    let arrayAFD = {};
    let arrayAlphabetAFD = [...alphabetAFND];
    // try {
    if (responseTableAFND.data != undefined) {
      Object.entries(responseTableAFND.data).forEach((item) => {
        // const arrayStates = Object.values(responseTable.data)[index];
        let initialState = item[0].split(" ")[0].replace(/\(/g, "");

        initialState = initialState
          .substr(0, initialState.length - 1)
          .trim()
          .replaceAll(",", "");
        let label = item[0].split(" ")[1].split(")")[0].trim();
        if (!arrayAlphabetAFD.includes(label)) {
          arrayAlphabetAFD.push(label);
        }
        if (!(initialState in arrayAFD)) {
          arrayAFD[initialState] = [];
          if (
            importantStatesAFND["initial"].includes(initialState) &&
            importantStatesAFND["final"] != undefined &&
            importantStatesAFND["final"].includes(initialState)
          ) {
            arrayAFD[initialState].push({
              initial: true,
              final: true,
              name: initialState,
            });
          } else if (importantStatesAFND["initial"].includes(initialState)) {
            arrayAFD[initialState].push({
              initial: true,
              name: initialState,
            });
          } else if (
            importantStatesAFND["final"] != undefined &&
            importantStatesAFND["final"].includes(initialState)
          ) {
            arrayAFD[initialState].push({
              final: true,
              name: initialState,
            });
          } else {
            arrayAFD[initialState].push(initialState);
          }
        }
        if (item[1].length == 0) {
          arrayAFD[initialState].push("{ }");
        } else {
          let states = "";
          item[1].forEach((state, index) => {
            if (index == 0) {
              states += "{";
            }
            states += state.name.replaceAll(",", "") + ", ";
            if (index == item[1].length - 1) {
              states = states.trim();
              states = states.substring(0, states.length - 1);
              states += "}";
            }
          });
          arrayAFD[initialState].push(states);
        }

        // createData(initialState, label, arrayStates);
      });
      setAlphabetAFND(arrayAlphabetAFD);
      setTableAFND(arrayAFD);
      if (responseTableAFNDLambda.data == undefined) {
        setRowsAFND(arrayAFD);
      }
    }
    // } catch (e) {
    //   alert("Exceção desconhecida");
    // }
  };
  useEffect(() => {
    if (dot != "") setImportantStates("AFNDLambda", dot);
    if (afndDot != "") setImportantStates("AFND", afndDot);
    if (drawableDot != "") setImportantStates("AFD", drawableDot);
    if (drawableDot != "") setImportantStates("Minimization", drawableDot);

    fechTableMinimization();
    fechTableAFNDLambda();
    fechTableAFND();
    fechTableAFD();
  }, [...Object.values(responseTableAFNDLambda)]);

  useEffect(() => {
    if (isOpenTableAFD) {
      setContentDialog(dialogConstantes.AFNDToAFD.content[language]);
      setTitleDialog(dialogConstantes.AFNDToAFD.title[language]);
    } else if (isOpenTableAFND && responseTableAFNDLambda.data != undefined) {
      setContentDialog(dialogConstantes.AFNDLamdaToAFND.content[language]);
      setTitleDialog(dialogConstantes.AFNDLamdaToAFND.title[language]);
    } else if (isOpenTableAFND) {
      setContentDialog(dialogConstantes.AFNDToAFD.content[language]);
      setTitleDialog(dialogConstantes.AFNDToAFD.title[language]);
    } else if (isOpenTableMinimization) {
      setContentDialog(dialogConstantes.Minimization.content[language]);
      setTitleDialog(dialogConstantes.Minimization.title[language]);
    } else if (
      responseTableMinimization.data == undefined &&
      responseTableAFNDLambda.data == undefined
    ) {
      setDisableNextButton(true);
      setDisablePreviousButton(true);
      setDisabledAlgorithmButton(true);
    }
  }, [isOpenTableAFD, isOpenTableAFND, isOpenTableMinimization]);

  const setImportantStates = (typeDot, stringDot) => {
    let importantStatesTemp = [];

    if (typeDot == "AFNDLambda") {
      importantStatesTemp = importantStatesAFNDLambda;
    } else if (typeDot == "AFD") {
      importantStatesTemp = importantStatesAFD;
    } else if (typeDot == "AFND") {
      importantStatesTemp = importantStatesAFND;
    } else if (typeDot == "Minimization") {
      importantStatesTemp = importantStatesDraw;
    }
    let importantStates = stringDot.split("\n\n")[2];
    importantStates = importantStates.split(";");
    for (let i = 0; i < importantStates.length - 1; i++) {
      let line = importantStates[i];
      const state = line.split("[")[0].replaceAll(",", "").trim();
      const type = line.split("shape=")[1].split("]")[0].trim();
      if (type == "square") {
        if (importantStatesTemp["final"] == undefined) {
          importantStatesTemp["final"] = [state];
        } else {
          importantStatesTemp["final"].push(state);
        }
      } else if (type == "diamond") {
        if (importantStatesTemp["initial"] == undefined) {
          importantStatesTemp["initial"] = [state];
        } else {
          importantStatesTemp["initial"].push(state);
        }
      } else if (type == "Mdiamond") {
        if (importantStatesTemp["final"] == undefined) {
          importantStatesTemp["final"] = [state];
        } else {
          importantStatesTemp["final"].push(state);
        }
        if (importantStatesTemp["initial"] == undefined) {
          importantStatesTemp["initial"] = [state];
        } else {
          importantStatesTemp["initial"].push(state);
        }
      }
    }

    if (typeDot == "AFNDLambda") {
      setImportantStatesAFNDLambda({ ...importantStatesTemp });
    } else if (typeDot == "AFD") {
      console.log({ ...importantStatesTemp });
      setImportantStatesAFD({ ...importantStatesTemp });
    } else if (typeDot == "AFND") {
      setImportantStatesAFND({ ...importantStatesTemp });
    } else if (typeDot == "Minimization") {
      setImportantStatesDraw({ ...importantStatesTemp });
    }
  };
  const changePosition = (arr, from, to) => {
    arr.splice(to, 0, arr.splice(from, 1)[0]);
    return arr;
  };
  const fechTableAFNDLambda = () => {
    let array = {};
    let arrayAlphabet = [...alphabetAFNDLambda];
    if (responseTableAFNDLambda.data != undefined) {
      Object.entries(responseTableAFNDLambda.data).forEach((item) => {
        // const arrayStates = Object.values(responseTable.data)[index];
        let initialState = item[0].split(" ")[0].replace(/\(/g, "");
        initialState = initialState
          .substr(0, initialState.length - 1)
          .trim()
          .replaceAll(",", "");
        let label = item[0].split(" ")[1].split(")")[0].trim();
        if (label == "*") {
          if (
            !arrayAlphabet.includes(
              tableConstantes.transitionTables.clousure[language]
            )
          ) {
            arrayAlphabet.push(
              tableConstantes.transitionTables.clousure[language]
            );
          }
        } else {
          if (!arrayAlphabet.includes(label)) {
            arrayAlphabet.push(label);
          }
        }

        if (!(initialState in array)) {
          array[initialState] = [];
          if (
            importantStatesAFNDLambda["initial"].includes(initialState) &&
            importantStatesAFNDLambda["final"] != undefined &&
            importantStatesAFNDLambda["final"].includes(initialState)
          ) {
            array[initialState].push({
              initial: true,
              final: true,
              name: initialState,
            });
          } else if (
            importantStatesAFNDLambda["initial"].includes(initialState)
          ) {
            array[initialState].push({
              initial: true,
              name: initialState,
            });
          } else if (
            importantStatesAFNDLambda["final"] != undefined &&
            importantStatesAFNDLambda["final"].includes(initialState)
          ) {
            array[initialState].push({
              final: true,
              name: initialState,
            });
          } else {
            array[initialState].push(initialState);
          }
        }
        if (label == "*") {
          let fecho = "";
          item[1].forEach((state, index) => {
            if (index == 0) {
              fecho += "{";
            }
            fecho += state.name.replaceAll(",", "") + ", ";
            if (index == item[1].length - 1) {
              fecho = fecho.trim();
              fecho = fecho.substring(0, fecho.length - 1);
              fecho += "}";
            }
          });
          array[initialState].push(fecho);
        } else {
          if (item[1].length == 0) {
            array[initialState].push("{ }");
          } else {
            let states = "";
            item[1].forEach((state, index) => {
              if (index == 0) {
                states += "{";
              }
              states += state.name.replaceAll(",", "") + ", ";
              if (index == item[1].length - 1) {
                states = states.trim();
                states = states.substring(0, states.length - 1);
                states += "}";
              }
            });
            array[initialState].push(states);
          }
        }
        // createData(initialState, label, arrayStates);
      });
      changePosition(arrayAlphabet, 1, arrayAlphabet.length - 1);
      setAlphabetAFNDLambda(arrayAlphabet);
      Object.keys(array).map((el) => {
        const arr = array[el];
        changePosition(arr, 1, arr.length - 1);
      });
      setRows(array);
    }
  };
  const fechTableAFD = () => {
    let array = {};
    let arrayAlphabet = [...alphabetAFD];
    if (responseTableAFD.data != undefined) {
      console.log(responseTableAFD.data);
      Object.entries(responseTableAFD.data).forEach((item) => {
        // const arrayStates = Object.values(responseTable.data)[index];
        let initialState = item[0].split(" ")[0].replace(/\(/g, "");
        initialState = initialState
          .substr(0, initialState.length - 1)
          .trim()
          .replaceAll(",", "");
        let label = item[0].split(" ")[1].split(")")[0].trim();
        if (!arrayAlphabet.includes(label)) {
          arrayAlphabet.push(label);
        }
        if (!(initialState in array)) {
          array[initialState] = [];
          if (
            importantStatesAFD["initial"].includes(initialState) &&
            importantStatesAFD["final"] != undefined &&
            importantStatesAFD["final"].includes(initialState)
          ) {
            array[initialState].push({
              initial: true,
              final: true,
              name: initialState,
            });
          } else if (importantStatesAFD["initial"].includes(initialState)) {
            array[initialState].push({
              initial: true,
              name: initialState,
            });
          } else if (
            importantStatesAFD["final"] != undefined &&
            importantStatesAFD["final"].includes(initialState)
          ) {
            array[initialState].push({
              final: true,
              name: initialState,
            });
          } else {
            array[initialState].push(initialState);
          }
        }

        if (item[1].length == 0) {
          array[initialState].push("-");
        } else {
          let states = "";
          item[1].forEach((state, index) => {
            states += state.name.replaceAll(",", "") + ", ";
            if (index == item[1].length - 1) {
              states = states.trim();
              states = states.substring(0, states.length - 1);
            }
          });
          array[initialState].push(states);
        }

        // createData(initialState, label, arrayStates);
      });
      setAlphabetAFD(arrayAlphabet);
      setTableAFD(array);
    }
  };

  useEffect(() => {
    DataService.isAlive({
      headers: {
        Authorization: credential,
      },
    })
      .then((res) => {
        setIsAlive(res.data);
        if (!res.data) {
          return <SystemOff />;
        }
      })
      .catch((e) => {
        alert(e);
      });
  }, []);

  useEffect(() => {
    document.addEventListener("contextmenu", function (event) {
      event.preventDefault();
    });
    if (drawableDot.length > 0 && !dragEnd) {
      setLoading(true);

      drawDOTtoAutomaton(drawableDot);
      setLoading(false);
    }
  }, [drawableDot]);

  const deleteCell = () => {
    if (disableNextButton) setDisableNextButton(false);
    if (!isOpenTableMinimization) {
      let rowsTemp;
      let change = false;
      if (isTableAFND) {
        rowsTemp = rowsAFND;
      } else if (isTableAFD) {
        rowsTemp = rowsAFD;
      }
      const indexLastKey = Object.keys(rowsTemp).length;
      const key = Object.keys(rowsTemp)[indexLastKey - 1];
      if (rowsTemp[key] != undefined && rowsTemp[key].length == 1) {
        delete rowsTemp[key];
      } else if (rowsTemp[key] != undefined) {
        rowsTemp[key].pop();
      } else if (Object.keys(rows) > 0) {
        change = true;
      } else {
        setAlert({
          active: true,
          text: tableConstantes.info.notGoBack[language],
          color: "danger",
          sevarity: "info",
          icon: ErrorOutlineIcon,
        });
        setDisablePreviousButton(true);
      }
      if (isTableAFND) {
        setRowsAFND({ ...rowsTemp });
      } else {
        setRowsAFD({ ...rowsTemp });
      }
      if (change && isTableAFD) {
        setIsOpenTableAFD(false);
        setIsOpenTableAFND(true);
        setIsTableAFND(true);
        setIsTableAFD(false);
        setAlert({
          active: true,
          text: "Retornando a tabela AFND",
          color: "warning",
          sevarity: "info",
          icon: ErrorOutlineIcon,
        });
      } else if (change) {
        setAlert({
          active: true,
          text: tableConstantes.info.notGoBack[language],
          color: "danger",
          sevarity: "info",
          icon: ErrorOutlineIcon,
        });
        setDisablePreviousButton(true);
      }
    } else {
      let lastKeyMinimizationModificatedTemp = lastKeyMinimizationModificated;
      let tableMinimizationTemp = tableMinimization;
      const keys = Object.keys(tableMinimizationTemp);
      let key = lastKeyMinimizationModificatedTemp.pop();
      if (key != undefined && Object.keys(key).length > 0) {
        const indexKey = keys.indexOf(key);
        const lastKey = Object.keys(tableMinimizationTemp)[indexKey - 1];
        if (lastKey != undefined) {
          tableMinimizationTemp[lastKey][0].actual = true;
          // "• " + tableMinimizationTemp[lastKey][0];
        }
        tableMinimizationTemp[key][0].actual = false;
        tableMinimizationTemp[key][1] = { name: "✔", color: "black" };
        tableMinimizationTemp[key][3] = { name: "", color: "black" };

        // tableMinimizationTemp["(q0, q4)"][0] = "blabla";
        Object.values(tableMinimizationTemp).forEach((e) => {
          const keyModificated = e[0].name != undefined ? e[0].name : e[0];

          if (e[2].name != undefined && e[2].name.includes(key)) {
            let replaceText = "";
            const qtdComas = tableMinimizationTemp[
              keyModificated
            ][2].name.match(new RegExp(",", "g"));
            let keyReplaced = key;
            if (qtdComas.length > 1) {
              keyReplaced = ", " + key;
            } else {
              replaceText = "{ }";
            }
            tableMinimizationTemp[
              keyModificated
            ][2].name = tableMinimizationTemp[keyModificated][2].name.replace(
              keyReplaced,
              replaceText
            );

            tableMinimizationTemp[keyModificated][2].color = "black";
            tableMinimizationTemp[keyModificated][1] = {
              name: "✔",
              color: "black",
            };
          }
          if (e[3].name != undefined && e[3].name.includes(key)) {
            tableMinimizationTemp[keyModificated][3].name = "";
            tableMinimizationTemp[keyModificated][1] = {
              name: "✔",
              color: "black",
            };
            // tableMinimizationTemp[keyModificated].pop();
            // tableMinimizationTemp[keyModificated].push("");
          }
        });

        setTableMinimization({ ...tableMinimizationTemp });
        setInsertKeyMinimization(insertKeyMinimization - 1);
      } else {
        setAlert({
          active: true,
          text: tableConstantes.info.notGoBack[language],
          color: "danger",
          sevarity: "info",
          icon: ErrorOutlineIcon,
        });
        setDisablePreviousButton(true);
      }
    }
  };
  const changeColorLastModificatedCells = (table, arrayModificated) => {
    if (arrayModificated != undefined)
      arrayModificated.forEach((index) => {
        const key = Object.keys(table)[index];
        table[key][1].color = "black";
        if (table[key][2].color != undefined) table[key][2].color = "black";
        if (table[key][3].color != undefined) table[key][3].color = "black";
      });
  };
  const insertCell = () => {
    if (disablePreviousButton) setDisablePreviousButton(false);
    if (!isOpenTableMinimization) {
      let rowsTemp;
      let referenceTable;
      let change = false;
      if (isTableAFND) {
        rowsTemp = rowsAFND;
        referenceTable = tableAFND;
        if (Object.keys(rowsTemp).length == 0) {
          setIsOpenTableAFND(true);
        }
      } else if (isTableAFD) {
        rowsTemp = rowsAFD;
        referenceTable = tableAFD;
      }
      const lastKeyIndex = Object.keys(rowsTemp).length;

      if (lastKeyIndex == 0) {
        const firstKey = Object.keys(referenceTable)[0];
        rowsTemp[firstKey] = [referenceTable[firstKey][0]];
      } else {
        const statesKey = Object.keys(rowsTemp)[lastKeyIndex - 1];
        const statesByKey = rowsTemp[statesKey];
        if (statesByKey.length < alphabetAFD.length) {
          const lastKey = Object.keys(referenceTable)[lastKeyIndex - 1];
          const lastStateIndex = rowsTemp[lastKey].length;
          if (lastStateIndex == 0) {
            rowsTemp[lastKey].push(referenceTable[lastKey][0]);
          } else {
            rowsTemp[lastKey].push(referenceTable[lastKey][lastStateIndex]);
          }
        } else {
          if (Object.keys(referenceTable)[lastKeyIndex] != undefined) {
            const newKey = Object.keys(referenceTable)[lastKeyIndex];
            rowsTemp[Object.keys(referenceTable)[lastKeyIndex]] = [
              referenceTable[newKey][0],
            ];
          } else {
            change = true;
          }
        }
      }

      if (isTableAFND) {
        setRowsAFND({ ...rowsTemp });
      } else {
        setRowsAFD({ ...rowsTemp });
      }
      if (change) {
        if (isTableAFND) {
          setAlert({
            active: true,
            text: tableConstantes.info.transitionAFNDLamdaToAFND[language],
            color: "success",
            sevarity: "info",
            icon: CheckIcon,
          });
          setIsTableAFD(true);
          setIsOpenTableAFD(true);
          setIsTableAFND(false);
        } else if (isTableAFD) {
          setAlert({
            active: true,
            text: tableConstantes.info.transitionAFNDToAFD[language],
            color: "success",
            sevarity: "info",
            icon: CheckIcon,
          });
          setDisableNextButton(true);
        }
      }
    } else {
      if (insertedFinalAndNotFinal == null) {
        const keys = Object.keys(finalAndNotFinals);
        let temp = tableMinimization;
        keys.forEach((key) => {
          temp[key][1] = { name: "✔ ➞ ✖", color: "red" };
          temp[key][3] = { name: finalAndNotFinals[key], color: "red" };
        });

        setAlert({
          active: true,
          text: tableConstantes.info.minimizationTable[language],
          color: "success",
          sevarity: "info",
          icon: CheckIcon,
        });
        setInsertedFinalAndNotFinal(true);
        setTableMinimization({ ...temp });
      } else if (insertedFinalAndNotFinal) {
        const keys = Object.keys(finalAndNotFinals);
        let temp = tableMinimization;
        keys.forEach((key) => {
          delete temp[key];
        });
        setTableMinimization({ ...temp });

        setInsertedFinalAndNotFinal(false);
      } else {
        let arrayChangeColorCellTemp = [];
        let lastKeyMinimizationModificatedtemp = lastKeyMinimizationModificated;
        let temp = tableMinimization;

        const key = Object.keys(temp)[insertKeyMinimization];
        const previousKey = Object.keys(temp)[insertKeyMinimization - 1];
        const changeCellColors = arrayChangeColorCell;
        changeColorLastModificatedCells(temp, changeCellColors);

        if (key in subject) {
          const sub = subject[key];

          sub.forEach((e) => {
            if (temp[e][2].name != undefined && temp[e][2].name != "{ }") {
              temp[e][2].name += ", " + key;
            } else {
              temp[e][2] = { name: key, color: "red" };
            }
            const keys = Object.keys(temp);
            const index = keys.indexOf(e);
            arrayChangeColorCellTemp.push(index);
          });

          setArrayChangeColorCell([...arrayChangeColorCellTemp]);
        }

        if (key != undefined) {
          if (temp[key][0].actual == undefined) {
            temp[key][0] = { name: temp[key][0], actual: true };
          } else {
            temp[key][0].actual = true;
          }
          if (temp[previousKey] != undefined) {
            temp[previousKey][0].actual = false;
            temp[previousKey][1].color != undefined
              ? (temp[previousKey][1].color = "black")
              : null;
            temp[previousKey][2].color != undefined
              ? (temp[previousKey][2].color = "black")
              : null;
            temp[previousKey][3].color != undefined
              ? (temp[previousKey][3].color = "black")
              : null;
          }
          //Quer dizer que o conjunto está errado por algum motivo
          if (key in reason) {
            if (reason[key] != "") {
              // lastKeyMinimizationModificatedtemp.push(key);
              // setlastKeyMinimizationModificated(
              //   lastKeyMinimizationModificatedtemp
              // );
              temp[key][1] = { name: "✔ ➞ ✖", color: "red" };
              temp[key][3] = { name: reason[key], color: "red" };
              const keys = Object.keys(temp);
              const index = keys.indexOf(key);
              arrayChangeColorCellTemp.push(index);
              //Necessário ver se há algum dado no subject, se tiver é necessário propagar
              Object.keys(subject).forEach((KEY) => {
                const array = subject[KEY];
                //Erros diretos
                array.forEach((set) => {
                  if (set == key) {
                    const prop = propagation[key];
                    let arrayPropagation = [];
                    if (prop != undefined) {
                      arrayPropagation = propagationCell(key);
                    }
                    //Erros indiretos
                    arrayPropagation.forEach((e) => {
                      if (
                        temp[e][3] == "" ||
                        (temp[e][3].name != undefined && temp[e][3].name == "")
                      ) {
                        temp[e][1] = { name: "✔ ➞ ✖", color: "red" };
                        temp[e][3] = { name: "oprop " + key, color: "red" };
                        const keys = Object.keys(temp);
                        const index = keys.indexOf(e);
                        arrayChangeColorCellTemp.push(index);
                      }
                    });
                    setPropagationByKey([]);
                  }
                });
              });
              // if (key in subject) {
              //   const prop = propagation[key];
              //   let arrayPropagation = [];
              //   if (prop != undefined) {
              //     arrayPropagation = propagationCell(key);
              //   }
              //   arrayPropagation.forEach((e) => {
              //     if (
              //       temp[e][3] == "" ||
              //       (temp[e][3].name != undefined && temp[e][3].name == "")
              //     ) {
              //       temp[e][1] = { name: "✔ ➞ ✖", color: "red" };
              //       temp[e][3] = { name: "oprop " + key, color: "red" };
              //       const keys = Object.keys(temp);
              //       const index = keys.indexOf(e);
              //       arrayChangeColorCellTemp.push(index);
              //     }
              //   });
              //   setPropagationByKey([]);
              // }
            }
          }
          // if (key in reason && !(key in subject)) {
          //   if (reason[key] != "") {
          //     // const lastInsert = temp[key];
          //     lastKeyMinimizationModificatedtemp.push(key);
          //     setlastKeyMinimizationModificated(
          //       lastKeyMinimizationModificatedtemp
          //     );
          //     temp[key][1] = { name: "✔ ➞ ✖", color: "red" };
          //     temp[key][3] = { name: reason[key], color: "red" };
          //     const keys = Object.keys(temp);
          //     const index = keys.indexOf(key);
          //     arrayChangeColorCellTemp.push(index);
          //   }
          //   const prop = propagation[key];
          //   let arrayPropagation = [];
          //   if (prop != undefined) {
          //     arrayPropagation = propagationCell(key);
          //   }
          //   arrayPropagation.forEach((e) => {
          //     if (
          //       temp[e][3] == "" ||
          //       (temp[e][3].name != undefined && temp[e][3].name == "")
          //     ) {
          //       temp[e][1] = { name: "✔ ➞ ✖", color: "red" };
          //       temp[e][3] = { name: "oprop " + key, color: "red" };
          //       const keys = Object.keys(temp);
          //       const index = keys.indexOf(e);
          //       arrayChangeColorCellTemp.push(index);
          //     }
          //   });
          //   setPropagationByKey([]);
          // }
          lastKeyMinimizationModificatedtemp.push(key);
          setlastKeyMinimizationModificated(lastKeyMinimizationModificatedtemp);
          setArrayChangeColorCell([...arrayChangeColorCellTemp]);
          setInsertKeyMinimization(insertKeyMinimization + 1);
        } else {
          setAlert({
            active: true,
            text: "Finalizada a Minimização",
            color: "success",
            sevarity: "info",
            icon: CheckIcon,
          });
          setDisableNextButton(true);
        }
        // const keys = Object.keys(reason);
        // let temp = tableMinimization;
        // keys.forEach((key) => {
        //   temp[key][2] = reason[key];
        // });
        // setTableMinimization({ ...temp });
      }
    }
  };
  // const handleShapeDragEnd = (e, machineState) => {
  //   var shape = e.target;
  //   const newX = shape.getX();
  //   const newY = shape.getY();
  //   machineState.setState({
  //     x: newX,
  //     y: newY,
  //   });
  //   machineState.updatePositions(childs2);
  // };
  const handleShapeDragEnd = (e, machineState, index) => {
    var shape = e.target;
    const newX = shape.getX();
    const newY = shape.getY();
    let tempState = [...machineStatesResponse];
    let obj = tempState[index];
    obj = Object.assign(obj, { x: newX, y: newY });
    tempState.splice(index, 1, obj);
    setMachineStatesResponse(tempState);
    for (let t of tranT) {
      if (t != null) {
        if (t.props.initial.text == machineState.props.text) {
          t.props.initial.xPos = newX;
          t.props.initial.yPos = newY;
        }
        if (t.props.final.text == machineState.props.text) {
          t.props.final.xPos = newX;
          t.props.final.yPos = newY;
        }
        t.updateTransitionPosition(false);
      }
    }
    // let dot = new DOT(tempState, machineTransitionsResponse);
    // dot.toDotLanguage();
    // setDrawableDot(dot.toString());
  };

  // const createStateFromDOT = (state, x, y, isInitial, isFinal) => {
  //   let objectState = {
  //     id: state,
  //     key: state,
  //     x: x,
  //     y: y,
  //     text: state,
  //     isInitial: isInitial,
  //     isFinal: isFinal,
  //     type: 1,
  //   };
  //   setStates([...states, objectState]);
  //   let newState = (
  //     <State
  //       id={state}
  //       key={state}
  //       x={x}
  //       y={y}
  //       text={state}
  //       isInitial={isInitial}
  //       isFinal={isFinal}
  //       type={1}
  //       ref={(e) => childs2.push(e)}
  //       onDragEnd={(e, inst) => {
  //         handleShapeDragEnd(e, inst);
  //       }}
  //     />
  //   );

  //   let children1 = responseDot;
  //   children1.push(newState);
  //   setResponseDot(children1);
  // };

  // const createTransitionFromDOT = (s1, s2, label) => {
  //   let childs = responseDot;
  //   let currentObject;
  //   let futureObject;
  //   for (let child of childs) {
  //     if (child != null && child.props.text === s1) {
  //       currentObject = {
  //         text: child.props.text,
  //         xPos: child.props.x,
  //         yPos: child.props.y,
  //       };
  //     }
  //     if (child != null && child.props.text === s2) {
  //       futureObject = {
  //         text: child.props.text,
  //         xPos: child.props.x,
  //         yPos: child.props.y,
  //       };
  //     }
  //   }

  //   if (currentObject != undefined && futureObject != undefined) {
  //     const tran = (
  //       <Transition
  //         initial={currentObject}
  //         final={futureObject}
  //         label={label}
  //         ref={(e) => childs2.push(e)}
  //         onClick={() => {}}
  //       />
  //     );

  //     let children1 = responseDot;
  //     children1.push(tran);

  //     setResponseDot(children1);
  //   }
  // };
  const propagationCell = (key) => {
    //utilizado para não ter dependencia cíclica
    let visited = [];
    let prop = propagation[key];
    let propagationQueueTemp = [];
    let propagationByKeyTemp = propagationByKey;
    propagationByKeyTemp = [...prop];
    propagationQueueTemp.push(...prop);
    while (propagationQueueTemp.length > 0) {
      let nextKey = propagationQueueTemp.shift();
      if (Array.isArray(nextKey)) {
        nextKey = nextKey[0];
      }
      prop = propagation[nextKey];
      if (prop != undefined) {
        prop.forEach((e) => {
          if (!visited.includes(e)) {
            propagationByKeyTemp.push(e);
            propagationQueueTemp.push(e);
            visited.push(e);
          }
        });
      }
    }
    return propagationByKeyTemp;
    // setPropagationByKey([...propagationByKeyTemp]);
  };

  const existTransition = (initial, final) => {
    let flag = false;
    for (let t of tranT) {
      if (t != null) {
        if (t.props.initial.text == final && t.props.final.text == initial) {
          flag = true;
        }
      }
    }
    return flag;
  };

  const updateTransitions = () => {
    setTimeout(() => {
      for (let t of tranT) {
        if (t != null) {
          const s1 = t.props.initial.text;
          const s2 = t.props.final.text;
          if (existTransition(s1, s2)) {
            t.updateTransitionPosition(true);
          } else {
            t.updateTransitionPosition(false);
          }
        }
      }
    }, 10);
  };

  const drawDOTtoAutomaton = (dot) => {
    // setStarts([]);
    // setChilds([]);
    // let newArrayTransitions = [];
    let maxHeigh = 0;
    let maxWidth = 0;
    try {
      const arrayRender = organizeArrayToRenderAutomata(dot);
      setMachineStatesResponse(arrayRender.states);
      setMachineTransitionsResponse(arrayRender.transitions);
      arrayRender.states.forEach((el) => {
        if (el.x > maxWidth) {
          maxWidth = el.x + 50;
        }
        if (el.y > maxHeigh) {
          maxHeigh = el.y + 50;
        }
      });
      if (maxHeigh < window.innerHeight) {
        setStageHight(window.innerHeight);
      } else {
        setStageHight(maxHeigh);
      }
      if (maxWidth < window.innerWidth) {
        setStageWidth(window.innerWidth);
      } else {
        setStageWidth(maxWidth);
      }

      updateTransitions();
      // for (let i = 0; i < arrayRender.states.length; i++) {
      //   const state = arrayRender.states[i];

      //   createStateFromDOT(
      //     state.text,
      //     state.x,
      //     state.y,
      //     state.isInitial,
      //     state.isFinal
      //   );
      // }

      // for (let i = 0; i < arrayRender.transitions.length; i++) {
      //   const transition = arrayRender.transitions[i];
      //   createTransitionFromDOT(
      //     transition.initial,
      //     transition.final,
      //     transition.label
      //   );
      // }
    } catch (e) {
      console.log(e);
      // alert(e);
    }
  };
  const openTransformationDialog = () => {
    setActiveTransformationAlgorithmDialog(true);
  };
  if (!isAlive && !isAdmin) {
    return <SystemOff />;
  }
  const copyAutomaton = () => {
    if (drawableDot.length > 0) {
      let dot = new DOT(machineStatesResponse, machineTransitionsResponse);
      dot.toDotLanguage();
      setDrawableDot(dot.toString());
      setDot(dot.toString());
      history.push("/user/automaton");
    } else {
      setAlert({
        active: true,
        text: tableConstantes.info.notGoBack[language],
        color: "danger",
        sevarity: "info",
        icon: ErrorOutlineIcon,
      });
    }
  };
  return (
    <div>
      <Loading loading={loading} />
      <TransformationAlgorithmdialog
        content={contentDialog}
        title={titleDialog}
      />
      <div className="wrapper-response">
        {Object.keys(responseSimulate).length > 0 ? (
          <div className="simulate">
            <div>
              <SimulateAutomata
                response={responseSimulate.responseSimulateAutomata}
              ></SimulateAutomata>

              {dataTreeDerivation != undefined && (
                <Tree
                  data={dataTreeDerivation}
                  // renderCustomNodeElement={
                  //   renderCustomNodeElement
                  //     ? (rd3tProps) => renderCustomNodeElement(...rd3tProps)
                  //     : undefined
                  // }
                  renderCustomNodeElement={renderRectSvgNode}
                  rootNodeClassName="demo-node"
                  branchNodeClassName="demo-node"
                  orientation="vertical"
                  translate={{
                    x: 200,
                    y: 300,
                  }}
                  collapsible={true}
                  initialDepth={1}
                  zoomable={true}
                  zoom={1}
                  scaleExtent={{ min: 0.1, max: 1 }}
                  nodeSize={{ x: 200, y: 200 }}
                  separation={{ siblings: 2, nonSiblings: 2 }}
                  enableLegacyTransitions={false}
                  transitionDuration={500}
                  depthFactor={undefined}
                  styles={stylesNodo}
                  shouldCollapseNeighborNodes={false}
                />
              )}
            </div>
          </div>
        ) : (
          <div className="response-tables">
            <div
              style={{ overflowX: "scroll" }}
              className="stage-response-area"
            >
              <div className="copy-button">
                <Button
                  title="Copiar Automato"
                  color="white"
                  aria-label="edit"
                  round="true"
                  disabled={drawableDot.length == 0}
                  onClick={() => {
                    copyAutomaton();
                  }}
                >
                  <CopyIcon />
                </Button>
              </div>

              <Stage
                // style={{ backgroundColor: "#E2E2E2", overflowY: "hidden" }}
                width={stageWidth}
                height={stageHight}
                onContextMenu={(e) => {
                  e.evt.preventDefault();
                }}
              >
                <Layer>
                  {machineTransitionsResponse.map((obj, index) => {
                    return (
                      <Transition
                        key={index}
                        // id={"tran" + index}
                        initial={obj.initial}
                        final={obj.final}
                        label={obj.label}
                        stroke={obj.stroke}
                        onClick={() => {}}
                        strokeWidth={obj.strokeWidth}
                        ref={(iam) => {
                          let temp = tranT;
                          if (!temp.includes(iam)) {
                            temp.push(iam);
                            setTranT(temp);
                          }
                        }}
                      />
                    );
                  })}
                  {machineStatesResponse.map((obj, index) => (
                    <State
                      onClick={() => {}}
                      id={obj.text}
                      key={index}
                      x={obj.x}
                      y={obj.y}
                      color={obj.color}
                      text={obj.text}
                      isInitial={obj.isInitial}
                      isFinal={obj.isFinal}
                      visible={obj.visible}
                      draggable={true}
                      onDragEnd={(e, element) => {
                        handleShapeDragEnd(e, element, index);
                      }}
                    />
                  ))}
                </Layer>
              </Stage>
            </div>
            <div
              className="tables"
              style={{ backgroundColor: "rgba(0,0,0,0.05)" }}
            >
              <div className="step-buttons">
                <Button
                  onClick={() => {
                    deleteCell();
                  }}
                  disabled={disablePreviousButton}
                  color="primary"
                  variant="contained"
                >
                  <NavigateBeforeOutlinedIcon />
                  {tableConstantes.buttons.previous[language]}
                </Button>
                <Button
                  onClick={() => {
                    insertCell();
                  }}
                  disabled={disableNextButton}
                  color="primary"
                  variant="contained"
                >
                  {tableConstantes.buttons.next[language]}
                  <NavigateNextIcon />
                </Button>
                <Button
                  onClick={() => {
                    openTransformationDialog();
                  }}
                  disabled={disabledAlgorithmButton}
                  color="inherit"
                  variant="contained"
                >
                  {tableConstantes.buttons.algorithm[language]}
                </Button>
              </div>

              {/* <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  {alphabetAFNDLambda.map((row, index) => (
                    <TableCell key={index} scope="row">
                      {row}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(rows).map((item, index) => (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    style={index % 2 == 0 ? { backgroundColor: "blue" } : {}}
                  >
                    <TableCell component="th" scope="row">
                      {item}
                    </TableCell>
                    {rows[item].map((states, index) => (
                      <TableCell key={index} component="th" scope="row">
                        {states}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer> */}
              <div>
                {Object.keys(rows).length > 0 && (
                  <TableTransitions
                    open={true}
                    alphabet={alphabetAFNDLambda}
                    rows={rows}
                    titleTable={tableConstantes.table[language]}
                    title={
                      tableConstantes.transitionTables.AFNDLambda[language]
                    }
                  />
                )}
              </div>
              <div className="div-tables">
                {Object.keys(rowsAFND).length > 0 || isOpenTableAFND ? (
                  <TableTransitions
                    open={isOpenTableAFND}
                    alphabet={alphabetAFND}
                    rows={rowsAFND}
                    titleTable={tableConstantes.table[language]}
                    title={tableConstantes.transitionTables.AFND[language]}
                  />
                ) : null}
              </div>
              <div className="div-tables">
                {Object.keys(rowsAFD).length > 0 && (
                  <TableTransitions
                    open={isOpenTableAFD}
                    alphabet={alphabetAFD}
                    rows={rowsAFD}
                    titleTable={tableConstantes.table[language]}
                    title={tableConstantes.transitionTables.AFD[language]}
                  />
                )}
              </div>
              <div className="div-tables">
                {Object.keys(tableMinimization).length > 0 && (
                  <TableTransitions
                    open={true}
                    alphabet={headerTableMinimization}
                    rows={tableMinimization}
                    titleTable="Tabela Minimização"
                    title={tableConstantes.transitionTables.AFD[language]}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
